module.exports = __webpack_public_path__ + "static/media/logo.546216f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo.jpg
// module id = 706
// module chunks = 0